<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100">
    <div fxLayout="column" fxLayoutAlign="center center">
      <Teranet-PageTitle [PageTitle]="'Forgot Password'"></Teranet-PageTitle>
      <form [formGroup]="forgetPasswordForm"
            #userFormRef="ngForm"
            (ngSubmit)="onSubmit()">
        <div class="form-group-flex-column">
          <mat-label class="required-field-after">Email</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   [type]="'Email'"
                   formControlName="email"
                   [(ngModel)]="emailAddress"
                   required />
            <mat-error *ngIf="forgetPasswordForm.get('email').hasError('required')">
              {{ emailErrorMessage.EMAIL_REQUIRED }}
            </mat-error>
            <mat-error *ngIf="forgetPasswordForm.get('email').hasError('invalidEmail')">
              {{ emailErrorMessage.IS_NOT_EMAIL }}
            </mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="end">
          <button mat-raised-button class="plain-button" type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button class="theme-button" type="submit" [disabled]="!forgetPasswordForm.valid">Ok</button>
        </div>
      </form>
      <div class="form-group-flex-column">
        <div *ngIf="isError" class="alert alert-danger" role="alert">
          <div>{{ errorMessage }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
